import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import FormControl from "@mui/material/FormControl";
import {Radio, RadioGroup, Container as MContainer} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";

const Question = ({type, question, questionID, count, callback, spanish}) => {

  const renderOptions = (options) => {
    let toRender = [];
    if(type === "mc") options.forEach((opt) => {
      !opt.isDeleted && toRender.push(<FormControlLabel
        key={opt.id}
        value={opt.id}
        control={<Radio/>}
        label={opt.title.replace(/^\w/, (c) => c.toUpperCase())}
      />)
    })

    if(type === "tf") toRender = [
      <FormControlLabel key={1} value={true} control={<Radio/>} label={spanish ? "Correcto" : "True"}/>,
      <FormControlLabel key={2} value={false} control={<Radio/>} label={spanish ? "Incorrecto" : "False"}/>,
    ]

    return toRender;
  }

  const handleChange = (e) => {
    const value = e.target.value;

    if (type === "tf") {
      callback({ q: count, a: value === "true" ? "0" : "1" });
    } else if (type === "mc") {
      callback({ q: count, a: value });
    }
  };

  return (
    <MContainer key={questionID}>
      <h4>
        {count+1}. {question.title}
      </h4>
      <FormControl sx={{paddingLeft: 2}}>
        <RadioGroup onChange={handleChange}>
          {renderOptions(question.options)}
        </RadioGroup>
      </FormControl>
    </MContainer>
  );
}

Question.propTypes = {
  type: PropTypes.oneOf(['mc', 'tf']).isRequired,
  question: PropTypes.any.isRequired,
  questionID: PropTypes.any.isRequired,
  count: PropTypes.number,
  callback: PropTypes.func,
  spanish: PropTypes.bool
};

export default Question;
